<!-- 注册审批 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             :rules="dataRule"
             ref="dataForm">
      <div class="location-layout">
        <div class="reg-img">
          <img alt="" :src='dataForm.headurl' />
        </div>
        <el-row class="row-mar-l">
          <!-- 姓名 -->
          <el-col :span="6"
                  :offset="6">
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataForm.userName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 姓的拼音 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.firstname')">
              <el-input v-model="dataForm.lastName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 名的拼音 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.lastname')">
              <el-input v-model="dataForm.firstName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 证件类型 -->
          <el-col :span="6"
                  :offset="6">
            <el-form-item :label="$t('user.idtype')">
              <el-select v-model="dataForm.idType"
                         :placeholder="$t('user.idtype')"
                         :disabled="true">
                <el-option v-for="(item,index) in idTypeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 证件编号 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.passportIdcard')">
              <el-input v-model="dataForm.idcard"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 出生日期 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.dateofbirth')">
              <el-date-picker v-model="dataForm.birthday"
                              type="date"
                              :disabled="true"
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 性别 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.gender')">
              <el-select v-model="dataForm.sexCode"
                         filterable
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in sexCode"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 手机 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.mobile')">
              <el-input v-model="dataForm.mobile"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 邮箱 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.userEmail')">
              <el-input v-model="dataForm.email"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 最高学历 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.education')">
              <el-select v-model="dataForm.educationCode"
                         filterable
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in educationCode"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 组织类型 -->
          <el-col :span="6">
            <el-form-item :label="$t('organization.orgType')">
              <el-select v-model="dataForm.orgType"
                         filterable
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in userorgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 所属组织 -->
          <el-col :span="6">
            <!-- 经销商 -->
            <el-form-item :label="$t('user.affiliatedDeale')"
                          v-if="dataForm.orgType === '50' || dataForm.orgType === '60'">
              <el-select v-model="parentOrgId"
                         :disabled="true">
                <el-option v-for="item in orgArr"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 宝马集团 -->
            <el-form-item :label="$t('user.affiliatedGroup')"
                          v-else-if="dataForm.orgType === '10'">
              <el-select v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="item in orgArr"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 合作伙伴 -->
            <el-form-item :label="$t('user.affiliatedPartner')"
                          v-else-if="dataForm.orgType === '20'">
              <el-select v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="item in orgArr"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 合作院校 -->
            <el-form-item :label="$t('user.affiliatedCollege')"
                          v-else-if="dataForm.orgType === '30'">
              <el-select v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="item in orgArr"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 经销商集团 -->
            <el-form-item :label="$t('user.affiliatedDealerGroup')"
                          v-else-if="dataForm.orgType === '40'">
              <el-select v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="item in orgArr"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 紧急联系人及联系方式 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.emergencyContact')"
                          prop="emergencyContactInfo">
              <el-input v-model="dataForm.emergencyContactInfo"
                        :placeholder="$t('user.emergencyContactInput')"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 隐私协议 -->
          <!-- <el-col :span="6">
            <el-form-item :label="$t('user.privacyFileUrl')"
                          prop="privacyFileUrl"
                          style="width:90% !important">
              <div class="inline"
                   v-if="privacyFileUrl && privacyFileUrl !== ''">
                <a target="_blank"
                   :href='privacyFileUrl'
                   style="margin: 5px">用户隐私协议</a>
              </div>
              <div v-else
                   style="padding-top: 5px">暂无隐私协议</div>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-divider></el-divider>

        <!-- 宝马集团 -->
        <div v-if="dataForm.orgType === '10'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.authType"
                           :placeholder="$t('user.authTypePlaceholder')"
                           @change="changeAuthType"
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in perClassificationPartner"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 角色 -->
            <el-col :span="12"
                    style="text-align:center">
              <el-form-item :label="$t('user.role')"
                            prop="roleId"
                            style="width:90% !important">
                <el-select v-model="dataForm.roleId"
                           multiple
                           clearable
                           collapse-tags
                           :placeholder="$t('organization.orgCodeBring')"
                           :disabled="true">
                  <el-option v-for="(item,index) in rolelist"
                             :key="index"
                             :label="item.roleName"
                             :value="item.roleId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="isDisable"
                                :editable='false'
                                @change="orgJoinDateabled">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 部门 -->
              <el-form-item :label="$t('user.department')"
                            prop="bmwDeptCode">
                <el-input v-model="dataForm.bmwDeptCode"
                          :placeholder="$t('user.departmentInput')"
                          :disabled="isDisable"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-select v-model="dataForm.jobCode"
                             :placeholder="$t('user.positionSelect')"
                             :disabled="isDisable"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :remote-method="queryMainPosition"
                             @change="jobChangeNoSingle(dataForm.jobCode)">
                    <el-option v-for="(item,index) in positionlist"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 合作伙伴 -->
        <div v-if="dataForm.orgType === '20'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.authType"
                           :placeholder="$t('user.authTypePlaceholder')"
                           @change="changeAuthType"
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in perClassificationPartner"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 角色 -->
            <el-col :span="12"
                    style="text-align:center">
              <el-form-item :label="$t('user.role')"
                            prop="roleId"
                            style="width:90% !important">
                <el-select v-model="dataForm.roleId"
                           multiple
                           clearable
                           collapse-tags
                           :placeholder="$t('organization.orgCodeBring')"
                           :disabled="true">
                  <el-option v-for="(item,index) in rolelist"
                             :key="index"
                             :label="item.roleName"
                             :value="item.roleId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="isDisable"
                                :editable='false'
                                @change="orgJoinDateabled">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-select v-model="dataForm.jobCode"
                             :placeholder="$t('user.positionSelect')"
                             :disabled="isDisable"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :remote-method="queryMainPosition"
                             @change="jobChangeNoSingle(dataForm.jobCode)">
                    <el-option v-for="(item,index) in positionlist"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 合作院校 -->
        <div v-if="dataForm.orgType === '30'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.authType"
                           :placeholder="$t('user.authTypePlaceholder')"
                           @change="changeAuthType"
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in perClassificationPartnerInstitution"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 角色 -->
            <el-col :span="12"
                    style="text-align:center">
              <el-form-item :label="$t('user.role')"
                            prop="roleId"
                            style="width:90% !important">
                <el-select v-model="dataForm.roleId"
                           multiple
                           clearable
                           collapse-tags
                           :placeholder="$t('organization.orgCodeBring')"
                           :disabled="true">
                  <el-option v-for="(item,index) in rolelist"
                             :key="index"
                             :label="item.roleName"
                             :value="item.roleId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="isDisable"
                                :editable='false'
                                @change="orgJoinDateabled">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-select v-model="dataForm.jobCode"
                             :placeholder="$t('user.positionSelect')"
                             :disabled="isDisable"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :remote-method="queryMainPosition"
                             @change="jobChangeNoSingle(dataForm.jobCode)">
                    <el-option v-for="(item,index) in positionlist"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- BEST学员信息 -->
          <el-row class="row-mar-l"
                  v-if="dataForm.authType === '50' && false">
            <el-col :span="6">
              <!-- 预签约经销商 -->
              <el-form-item :label="$t('user.reservedDistributor')"
                            prop="dealerShipId">
                <el-select v-model="dataForm.dealerShipId"
                           remote
                           clearable
                           filterable
                           reserve-keyword
                           :placeholder="$t('user.dealerPlaceholder')"
                           :remote-method="orgquerySearch"
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in orgresulets"
                             :key="index"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- BEST候选人账号 -->
              <el-form-item :label="$t('user.numberbankaccount')"
                            prop="officialAccountFlag">
                <el-select v-model="dataForm.officialAccountFlag"
                           :placeholder="$t('user.numberbankaccountSelect')"
                           clearable
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in regularid"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 在校状态 -->
              <el-form-item :label="$t('user.graduation')"
                            prop="graduateStatus">
                <el-select :placeholder="$t('user.graduateStatusPlaceholder')"
                           v-model="dataForm.graduateStatus"
                           clearable
                           @change="graduateStatusChange"
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in graduationStatus"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-if="dataForm.graduateStatus === '10'">
              <!-- 入校时间 -->
              <el-form-item :label="$t('user.joinschool')"
                            prop="enterSchoolDate">
                <el-date-picker v-model="dataForm.enterSchoolDate"
                                type="date"
                                :placeholder="$t('user.enterSchoolPlaceholder')"
                                value-format="yyyy-MM-dd"
                                :disabled="isDisable">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-if="dataForm.graduateStatus === '20' || dataForm.graduateStatus === '30'">
              <!-- 离校时间 -->
              <el-form-item :label="$t('user.leaveschool')"
                            prop="leaveSchoolDate">
                <el-date-picker v-model="dataForm.leaveSchoolDate"
                                type="date"
                                :placeholder="$t('user.leaveschoolSelect')"
                                value-format="yyyy-MM-dd"
                                :disabled="isDisable">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 经销商集团 -->
        <div v-if="dataForm.orgType === '40'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.authType"
                           :placeholder="$t('user.authTypePlaceholder')"
                           @change="changeAuthType"
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in perClassificationPartner"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 角色 -->
            <el-col :span="12"
                    style="text-align:center">
              <el-form-item :label="$t('user.role')"
                            prop="roleId"
                            style="width:90% !important">
                <el-select v-model="dataForm.roleId"
                           multiple
                           clearable
                           collapse-tags
                           :placeholder="$t('organization.orgCodeBring')"
                           :disabled="true">
                  <el-option v-for="(item,index) in rolelist"
                             :key="index"
                             :label="item.roleName"
                             :value="item.roleId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="isDisable"
                                :editable='false'
                                @change="orgJoinDateabled">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-select v-model="dataForm.jobCode"
                             :placeholder="$t('user.positionSelect')"
                             :disabled="isDisable"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :remote-method="queryMainPosition"
                             @change="jobChangeNoSingle(dataForm.jobCode)">
                    <el-option v-for="(item,index) in positionlist"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 经销商 -->
        <div v-if="dataForm.orgType === '50' || dataForm.orgType === '60'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.authType"
                           :placeholder="$t('user.authTypePlaceholder')"
                           @change="changeAuthType"
                           :disabled="isDisable">
                  <el-option v-for="(item,index) in perClassificationPartner"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 角色 -->
            <el-col :span="12"
                    style="text-align:center">
              <el-form-item :label="$t('user.role')"
                            prop="roleId"
                            style="width:90% !important">
                <el-select v-model="dataForm.roleId"
                           multiple
                           clearable
                           collapse-tags
                           :placeholder="$t('organization.orgCodeBring')"
                           :disabled="true">
                  <el-option v-for="(item,index) in rolelist"
                             :key="index"
                             :label="item.roleName"
                             :value="item.roleId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 所属经销商网点 -->
              <el-form-item :label="$t('user.outlet')"
                            prop="orgId">
                <el-select v-model="dataForm.orgId"
                           filterable
                           clearable
                           :placeholder="$t('user.outletIDPlaceholder')"
                           @change="orgIdChange"
                           :disabled="isDisable">
                  <el-option v-for="item in outletArr"
                             :key="item.orgId"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                @change="orgJoinDateChange(dataForm.orgJoinDate)"
                                :disabled="isDisable"
                                :editable='false'>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 所属BBA No -->
              <el-form-item :label="$t('user.bbaNo')"
                            prop="bbaNo">
                <el-input v-model="dataForm.bbaNo"
                          :placeholder="$t('organization.orgCodeBring')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 所属品牌 -->
              <el-form-item :label="$t('user.brandCodes')">
                <el-select v-model="dataForm.brandCode"
                           :disabled="true"
                           :placeholder="$t('organization.orgCodeBring')">
                  <el-option v-for="(item,index) in brandCodeArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 所属NSC No -->
              <el-form-item :label="$t('user.nscno')"
                            prop="loginFlag">
                <el-input v-model="dataForm.nscNo"
                          :placeholder="$t('organization.orgCodeBring')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 网点类型 -->
              <el-form-item :label="$t('user.outletType')"
                            prop="">
                <el-input v-model="dataForm.outletType"
                          :placeholder="$t('organization.orgCodeBring')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 主要职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-select v-model="dataForm.jobCode"
                             :placeholder="$t('user.positionSelect')"
                             :disabled="isDisable || jobCodeshow"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :remote-method="queryMainPosition"
                             @change="jobLimit(dataForm.jobCode)">
                    <el-option v-for="(item,index) in positionlist"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 当前岗龄 -->
              <el-form-item :label="$t('user.jobyear')"
                            prop="loginFlag">
                <el-input v-model="dataForm.jobcodeAge"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入该职位日期 -->
              <el-form-item :label="$t('user.joinjobdate')"
                            prop="jobcodeJoinDate">
                <el-date-picker v-model="dataForm.jobcodeJoinDate"
                                type="date"
                                :disabled="true"
                                :placeholder="$t('organization.orgCodeBring')">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职1所属网点 -->
              <el-form-item :label="$t('user.outlet1')"
                            prop="partTimeOutletOne">
                <el-select v-model="dataForm.partTimeOutletOne"
                           filterable
                           clearable
                           :placeholder="$t('user.outlet1Select')"
                           @change="partOrgChange(dataForm.partTimeOutletOne, 0)"
                           :disabled="isDisable || partOrgShow">
                  <el-option v-for="item in outletArr"
                             :key="item.orgId"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位1 -->
              <el-form-item :label="$t('user.parttimejob1')">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeOne || dataForm.partTimeJobcodeOne === ''">
                  <div slot="content"
                       v-html="jobCodeContentOne"></div>
                  <el-select v-model="dataForm.partTimeJobcodeOne"
                             :placeholder="$t('user.parttimejob1Select')"
                             clearable
                             remote
                             filterable
                             reserve-keyword=""
                             :remote-method="queryJobPart0"
                             @change="parttimejobRepeat(dataForm.partTimeJobcodeOne, 'One', 0)"
                             :disabled="isDisable || parttimeShow0">
                    <el-option v-for="(item,index) in parttimejobList0"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职1日期 -->
              <el-form-item :label="$t('user.joinparttimejob1')"
                            prop="jobcodeJoinDateOne">
                <el-date-picker v-model="dataForm.jobcodeJoinDateOne"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点2 -->
              <el-form-item :label="$t('user.outlet2')"
                            prop="partTimeOutletTwo">
                <el-select v-model="dataForm.partTimeOutletTwo"
                           filterable
                           clearable
                           :placeholder="$t('user.outlet2Select')"
                           @change="partOrgChange(dataForm.partTimeOutletTwo, 1)"
                           :disabled="isDisable || partOrgShow">
                  <el-option v-for="item in outletArr"
                             :key="item.orgId"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位2 -->
              <el-form-item :label="$t('user.parttimejob2')"
                            prop="partTimeJobcodeTwo">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeTwo || dataForm.partTimeJobcodeTwo === ''">
                  <div slot="content"
                       v-html="jobCodeContentTwo"></div>
                  <el-select v-model="dataForm.partTimeJobcodeTwo"
                             :placeholder="$t('user.parttimejob2Select')"
                             clearable
                             remote
                             filterable
                             reserve-keyword=""
                             :remote-method="queryJobPart1"
                             @change="parttimejobRepeat(dataForm.partTimeJobcodeTwo, 'Two', 1)"
                             :disabled="isDisable || parttimeShow1">
                    <el-option v-for="(item,index) in parttimejobList1"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职2日期 -->
              <el-form-item :label="$t('user.joinparttimejob2')"
                            prop="jobcodeJoinDateTwo">
                <el-date-picker v-model="dataForm.jobcodeJoinDateTwo"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点3 -->
              <el-form-item :label="$t('user.outlet3')"
                            prop="partTimeOutletThree">
                <el-select v-model="dataForm.partTimeOutletThree"
                           filterable
                           clearable
                           :placeholder="$t('user.outlet3Select')"
                           @change="partOrgChange(dataForm.partTimeOutletThree, 2)"
                           :disabled="isDisable || partOrgShow">
                  <el-option v-for="item in outletArr"
                             :key="item.orgId"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位3 -->
              <el-form-item :label="$t('user.parttimejob3')"
                            prop="partTimeJobcodeThree">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeThree || dataForm.partTimeJobcodeThree === ''">
                  <div slot="content"
                       v-html="jobCodeContentThree"></div>
                  <el-select v-model="dataForm.partTimeJobcodeThree"
                             :placeholder="$t('user.parttimejob3Select')"
                             clearable
                             remote
                             filterable
                             reserve-keyword=""
                             :remote-method="queryJobPart2"
                             @change="parttimejobRepeat(dataForm.partTimeJobcodeThree, 'Three', 2)"
                             :disabled="isDisable || parttimeShow2">
                    <el-option v-for="(item,index) in parttimejobList2"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职3日期 -->
              <el-form-item :label="$t('user.joinparttimejob3')"
                            prop="jobcodeJoinDateThree">
                <el-date-picker v-model="dataForm.jobcodeJoinDateThree"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点4 -->
              <el-form-item :label="$t('user.outlet4')"
                            prop="partTimeOutletFour">
                <el-select v-model="dataForm.partTimeOutletFour"
                           filterable
                           clearable
                           :placeholder="$t('user.outlet4Select')"
                           @change="partOrgChange(dataForm.partTimeOutletFour, 3)"
                           :disabled="isDisable || partOrgShow">
                  <el-option v-for="item in outletArr"
                             :key="item.orgId"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位4 -->
              <el-form-item :label="$t('user.parttimejob4')"
                            prop="partTimeJobcodeFour">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeFour || dataForm.partTimeJobcodeFour === ''">
                  <div slot="content"
                       v-html="jobCodeContentFour"></div>
                  <el-select v-model="dataForm.partTimeJobcodeFour"
                             :placeholder="$t('user.parttimejob4Select')"
                             clearable
                             remote
                             filterable
                             reserve-keyword=""
                             :remote-method="queryJobPart3"
                             @change="parttimejobRepeat(dataForm.partTimeJobcodeFour, 'Four', 3)"
                             :disabled="isDisable || parttimeShow3">
                    <el-option v-for="(item,index) in parttimejobList3"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职4日期 -->
              <el-form-item :label="$t('user.joinparttimejob4')"
                            prop="jobcodeJoinDateFour">
                <el-date-picker v-model="dataForm.jobcodeJoinDateFour"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点5 -->
              <el-form-item :label="$t('user.outlet5')"
                            prop="partTimeOutletFive">
                <el-select v-model="dataForm.partTimeOutletFive"
                           filterable
                           clearable
                           :placeholder="$t('user.outlet5Select')"
                           @change="partOrgChange(dataForm.partTimeOutletFive, 4)"
                           :disabled="isDisable || partOrgShow">
                  <el-option v-for="item in outletArr"
                             :key="item.orgId"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位5 -->
              <el-form-item :label="$t('user.parttimejob5')"
                            prop="partTimeJobcodeFive">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeFive || dataForm.partTimeJobcodeFive === ''">
                  <div slot="content"
                       v-html="jobCodeContentFive"></div>
                  <el-select v-model="dataForm.partTimeJobcodeFive"
                             :placeholder="$t('user.parttimejob5Select')"
                             clearable
                             remote
                             filterable
                             reserve-keyword=""
                             :remote-method="queryJobPart4"
                             @change="parttimejobRepeat(dataForm.partTimeJobcodeFive, 'Five', 4)"
                             :disabled="isDisable || parttimeShow4">
                    <el-option v-for="(item,index) in parttimejobList4"
                               :key="index"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职5日期 -->
              <el-form-item :label="$t('user.joinparttimejob5')"
                            prop="jobcodeJoinDateFive">
                <el-date-picker v-model="dataForm.jobcodeJoinDateFive"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="((this.approval === 0||this.approval ==='0') && this.dataForm.fileManagementId !=='' && this.dataForm.fileManagementId !== null)
        ||((this.approval === 1||this.approval ==='1') && this.dataForm.fileManagementId !=='' && this.dataForm.fileManagementId !== null && this.userRole !== 'hradminAudit')">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <el-form-item :label="$t('authApply.fileName')"
                            prop="fileName">
                            <!-- 2021-02-01 修改样式 liujx-->
                <!-- <el-input v-model="dataForm.fileName"
                          :disabled="true"
                          @click.native="downloadFile"
                          class="custom"></el-input> -->
                          <el-input v-model="dataForm.fileName"
                          :disabled="true"
                          @click.native="downloadFile"
                          class="fl-input" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!--{{this.userRole}}-{{this.applyShow}}-{{this.dataForm.authType }}-{{ this.approval}} -->
        <div v-if="this.userRole === 'hradminAudit' && this.applyShow === '10' && this.dataForm.authType ==='10' &&  (this.approval === 1||this.approval ==='1')">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <el-form-item>
                <!-- 选取文件 -->
                <el-upload class="upload-demo"
                           ref="upload"
                           accept=".pdf,.PDF,.jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.PNG"
                           :show-file-list="false"
                           :data="myData"
                           :headers="myHeader"
                           :action="uploadUrl"
                           :on-preview="handlePreview"
                           :on-remove="handleRemove"
                           :on-success="handleSuccess"
                           :before-upload="beforeExcelUpload"
                           :file-list="fileList"
                           :auto-upload="true"
                           :multiple="false"
                           :on-change="changeFile">
                  <el-button slot="trigger"
                             type="primary"
                             style="margin-top: 27px; width: 200px">选择上传文件
                      <el-tooltip placement="top-start" effect="light" :content="$t('authApply.fileFormatContent')">
                      <em class="el-icon-question"></em>
                      </el-tooltip>
                  </el-button>
                  <el-link type="primary"
                           @click="downloadTemplate" style="margin-left:7px">模板下载</el-link>
                  <!-- <div slot="tip"
                       class="el-upload__tip">只支持PDF格式，文件不得超过20MB</div> -->
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('authApply.fileName')"
                            prop="fileName"
                            :rules="this.dataForm.fileName === ''||this.dataForm.fileName === null||this.dataForm.fileName === undefined? dataRule.fileName:
            [{ required: false, message: this.$t('validate.required'), trigger: 'change' }]">
                  <el-input v-model="dataForm.fileName"
                          :disabled="true"
                          @click.native="downloadFile"
                          class="fl-input"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <!-- 限制弹框 -->
    <el-dialog
      :title="$t('prompt.title')"
      :append-to-body="true"
      :modal-append-to-body="false"
      custom-class="user-transfer-islimit-modal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="limitShow"
      :before-close="closeLimitModal"
      :width="isLimit ? '760px' : '420px'">
        <LimitInfoModal v-if="limitShow" :isLimit="isLimit" :factoryDesc="factoryDesc" @closeLimitModal="closeLimitModal"></LimitInfoModal>
    </el-dialog>
  </el-card>
</template>

<script>
import Vue from 'vue'
import AesUtil from "@/utils/aes_utils";
import LimitInfoModal from '@/views/modules/acdc/limitAccess/limitModal';

// import debounce from 'lodash/debounce'
export default {
  components: {
    LimitInfoModal
  },
  data() {
    return {
      refsForm: {
        taApprovalFlag: '',
        taApprovalFlagOne: '',
        taApprovalFlagTwo: ''
      }, // 传递给父组件的流程参数
      dataForm: {
        roleId: []
      },
      // 所属经销商，拿到的orgId，传给后台的orgId是新选择的经销商网点的orgId
      parentOrgId: '',
      // 经销商网点下拉
      outletArr: [],
      // 所属组织下拉
      orgArr: [],
      // 兼职的展示与隐藏
      parttimeTwoshow: false,
      // 性别
      sexCode: this.enums['sex'],
      // 证件类型
      idTypeList: this.enums['idType'],
      // 学历
      educationCode: this.enums['educationCode'],
      // 组织类型
      userorgType: this.enums['orgType'],
      // 是否正式账号
      regularid: this.enums['confirmState'],
      // 毕业状态
      graduationStatus: this.enums['graduationStatus'],
      // 权限分类
      perClassification: this.enums['perClassification'],
      // 不包含Best学员权限分类
      perClassificationPartner: [],
      // 包含Best学员权限分类
      perClassificationPartnerInstitution: [],
      // 品牌
      brandCodeArr: this.enums['brandCode'],
      // 职位列表
      positionlist: [],
      jobCodeAll: '',
      // 预留签约经销商
      orgresulets: [],
      // 兼职数组
      parttimeCheckedList: [null, null, null, null],
      // 兼职1职位列表
      parttimejobList0: [],
      // 兼职2职位列表
      parttimejobList1: [],
      // 兼职3职位列表
      parttimejobList2: [],
      // 兼职4职位列表
      parttimejobList3: [],
      // 兼职5职位列表
      parttimejobList4: [],
      // 注册申请原始数据
      oldDataForm: {},
      // activiti中保存的流程申请时的注册申请数据
      actHistoryApplicantData: {},
      // 角色，根据角色判断，显示不同页面
      userRole: 'areaAudit',
      // 角色下拉框
      rolelist: [],
      // 判断表单是否可以编辑 userRole=hradminAudit false userRole=areaAudit true
      isDisable: false,
      // 主要职位可否编辑
      jobCodeshow: true,
      // 兼职网点可否编辑
      partOrgShow: true,
      // 兼职职位1可否编辑
      parttimeShow0: true,
      // 兼职职位2可否编辑
      parttimeShow1: true,
      // 兼职职位3可否编辑
      parttimeShow2: true,
      // 兼职职位4可否编辑
      parttimeShow3: true,
      // 兼职职位5可否编辑
      parttimeShow4: true,
      // 主要职位信息描述
      jobCodeNum: this.$t('activiti.jobCodeNum'),
      jobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 兼职职位描述
      jobCodeNumOne: this.$t('activiti.jobCodeNum'),
      jobCodeNumTwo: this.$t('activiti.jobCodeNum'),
      jobCodeNumThree: this.$t('activiti.jobCodeNum'),
      jobCodeNumFour: this.$t('activiti.jobCodeNum'),
      jobCodeNumFive: this.$t('activiti.jobCodeNum'),
      jobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentThree: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFour: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFive: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 历史版本离职日期
      historyLeaveDate: '',
      // 主页面是否通过，用于子页面表单验证
      canUpdate: false,
      // 1待办 0已办
      approval: 1,
      leaveAndJoinLeaveDate: '',
      privacyFileUrl: '',
      sysTime: '',
      uploadUrl: '',
      url: '/sys/commAdminFileManagement/uploadFileMT',
      myHeader: { token: '' },
      fileList: [],
      myData: {},
      saved: false,
      applyShow: '',
      dataMap: {},
      templeteFileName: '',
      limitShow: false,
      isLimit: false,
      factoryDesc: ''
    }
  },
  computed: {
    dataRule() {
      // 入职日期校验
      let accessionDate = (rule, value, callback) => {
        // let beforethreemonth = new Date().getTime() - 3600 * 1000 * 24 * 91
        // let afterthreemonth = new Date().getTime()
        // let date1 = new Date()
        //let beforethreemonth = new Date(Date.parse(this.sysTime.replace(/-/g, '/'))).getTime() - 3600 * 1000 * 24 * 31
        let afterthreemonth = new Date(Date.parse(this.sysTime.replace(/-/g, '/'))).getTime()
        let date1 = new Date(Date.parse(this.sysTime.replace(/-/g, '/')))
        let year = date1.getFullYear()
        var month = date1.getMonth()+1;
        let nowyear = new Date(Date.parse((year + '-' + month + '-' + '01').replace(/-/g, '/'))).getTime()
        let orgJoinDate = Date.parse(this.dataForm.orgJoinDate.replace(/-/g, '/'))
        if (new Date(orgJoinDate).getTime() > afterthreemonth) {
          callback(new Error(this.$t('user.monthOnebyone')))
        }
        if (nowyear > new Date(this.dataForm.orgJoinDate.replace(/-/g, '/')).getTime()) {
          // 2021-01-22 按刘莎要求改成90天提示信息
          // 2022-01-18  改为 30 天提示信息
          // callback(new Error(this.$t('user.onebyone')))
          callback(new Error(this.$t('user.monthOnebyone')))
        }
        if (this.historyLeaveDate !== '' && this.historyLeaveDate) {
          if (new Date(this.dataForm.orgJoinDate.replace(/-/g, '/')).getTime() < new Date(this.historyLeaveDate.replace(/-/g, '/')).getTime()) {
            callback(new Error(this.$t('user.verificationhistoryLeaveDate')))
          }
        }
        callback()
      }
      // 入校日期校验
      let joinSchoolDate = (rule, value, callback) => {
        let goschooltime = new Date(this.dataForm.enterSchoolDate)
        let leaveschooltime = new Date(this.dataForm.leaveSchoolDate)
        if (this.dataForm.enterSchoolDate !== '' && this.dataForm.enterSchoolDate !== undefined && this.dataForm.enterSchoolDate !== '' && this.dataForm.leaveSchoolDate !== '' && this.dataForm.leaveSchoolDate !== undefined && this.dataForm.leaveSchoolDate !== null) {
          if (goschooltime > leaveschooltime) {
            callback(new Error(this.$t('user.leavejoinschooldate')))
          } else {
            callback()
          }
        } else {
          callback()
        }
        callback()
      }
      // 离校日期校验
      let leaveSchoolDate = (rule, value, callback) => {
        let goschooltime = new Date(this.dataForm.enterSchoolDate)
        let leaveschooltime = new Date(this.dataForm.leaveSchoolDate)
        if (this.dataForm.enterSchoolDate !== '' && this.dataForm.enterSchoolDate !== undefined && this.dataForm.enterSchoolDate !== '' && this.dataForm.leaveSchoolDate !== '' && this.dataForm.leaveSchoolDate !== undefined && this.dataForm.leaveSchoolDate !== null) {
          if (goschooltime > leaveschooltime) {
            callback(new Error(this.$t('user.leavejoinschooldate1')))
          } else {
            callback()
          }
        }
        callback()
      }
      return {
        // 部门
        bmwDeptCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 权限分类
        authType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 所属经销商网点
        orgId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 入职日期
        orgJoinDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
          { validator: accessionDate, trigger: 'change' }
        ],
        // 主要职位
        jobCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 预签约经销商
        dealerShipId: [
          { required: true, message: this.$t('user.validatordealerShipId'), trigger: 'change' }
        ],
        // BEST候选人账号
        officialAccountFlag: [
          { required: true, message: this.$t('user.validatorofficialAccountFlag'), trigger: 'change' }
        ],
        // 入学校验
        joinschool: [
          { validator: joinSchoolDate, trigger: 'change' }
        ],
        // 离校校验
        leaveschool: [
          { validator: leaveSchoolDate, trigger: 'change' }
        ],
        // 在校状态
        graduateStatus: [
          { required: true, message: this.$t('user.verificationgraduate'), trigger: 'change' }
        ],
        fileName: [
          { required: true, message: this.$t('authApply.uploadFileFirst'), trigger: 'blur' }
        ],
      }
    }
  },
  // userRole hradminAudit 第一步审批 areaAudit 第二步审批
  created() {
    // 接收广播
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_UPCOMING, (data) => {
      if (this.$refs.dataForm) {
        this.positionlist = []
        this.orgresulets = []
        this.parttimejobList0 = []
        this.parttimejobList1 = []
        this.oldDataForm = {}
        this.outletArr = []
        this.rolelist = []
        this.initialization()
      }
    })
    this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url
    this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
    // 获取系统时间
    this.$request.get('/sys/commuser/sysDate',
    ).then((res, total, code, data) => {
      //this.sysTime = new Date(res.sysTime)
      this.sysTime = res.sysTime
    }).catch((err) => {
      console.log(err)
    })
    this.$request.get(`/sys/config/acquireOrgTypeSetting`).then((res, total, code, data) => {
      this.dataMap = new Map()
      for (let i = 0; i < res.length; i++) {
        this.dataMap.set(res[i].paramKey, res[i].paramValue)
      }
      if (this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)) {
        this.applyShow = this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)
      }
    }).catch((err) => {
      console.log(err)
    })
  },
  mounted() {
    this.initialization()
    let userId = ''
    if (this.dataForm.userId === '') {
      userId = ''
    } else {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      if (!isNaN(parseInt(userId, 10))) {
        userId = base64url.encode(aes.encrypt(this.dataForm.userId + ''))
      } else {
        userId = this.dataForm.userId
      }
    }
    this.myData = { userId: userId, type: '10', formal: '20', userRole: this.userRole }
  },
  methods: {
    // 页面初始化
    initialization() {
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields()
      }
      this.getPerClassification()
      this.dataForm = {}
      if (this.$route.query.approval !== undefined) { // 已办且审批通过需要计算宝龄和岗龄
        this.approval = this.$route.query.approval
      }
      if (this.$route.query.userId !== undefined) {
        this.jobCodeNum = this.$t('activiti.jobCodeNum')
        this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.dataForm.userId = this.$route.query.userId
        if (this.$refs.dataForm) {
          this.$refs['dataForm'].resetFields()
        }
        this.getActivitiApplicantInfo()
        this.getInfo()

        if (this.$route.query.userRole) {
          this.userRole = this.$route.query.userRole
          if (this.userRole === 'areaAudit') {
            this.isDisable = true
          } else if (this.userRole === 'hradminAudit') {
            this.isDisable = false
          } else if (this.userRole === 'areaManagerAudit') {
            this.isDisable = true
          } else {
            this.userRole = 'areaAudit'
            this.isDisable = true
          }
        }
      }
      this.$request.get(`/sys/commAdminFileManagement/getTempleteFileName`,
              {
                paramKey: 'ADMIN_LEVEL_TEMPLETE_FILE'
              }
      ).then((res, total, code, data) => {
        console.info('模板文件名称' + res)
        this.templeteFileName = res

      }).catch((err) => {
        console.log(err)
      })
    },
    graduateStatusChange() {
      this.dataForm.enterSchoolDate = ''
      this.dataForm.leaveSchoolDate = ''
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate(['enterSchoolDate', 'leaveSchoolDate'])
      })
    },
    // 获取主要职位list
    queryMainPosition(queryString) {
      console.warn(queryString)
      let orgType = this.dataForm.orgType
      if (orgType === '50') {
        orgType = '60'
      }
      this.$request.post('/sys/commuser/commPositionByParam',
        {
          orgType: orgType,
          orgId: this.dataForm.orgId,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.positionlist = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取不同组织类型的权限分类
    getPerClassification() {
      this.perClassificationPartner = []
      this.perClassificationPartnerInstitution = []
      let perClassification = this.perClassification
      for (let i = 0; i < perClassification.length; i++) {
        if (perClassification[i].code === '10') { // 管理员
          this.perClassificationPartner.push(perClassification[i])
          this.perClassificationPartnerInstitution.push(perClassification[i])
        } else if (perClassification[i].code === '20') { // 普通用户
          this.perClassificationPartner.push(perClassification[i])
          this.perClassificationPartnerInstitution.push(perClassification[i])
        } else if (perClassification[i].code === '50') { // Best学员
          // this.perClassificationPartnerInstitution.push(perClassification[i])
        } else if (perClassification[i].code === '40') { // 管理层
          this.perClassificationPartner.push(perClassification[i])
          this.perClassificationPartnerInstitution.push(perClassification[i])
        }
      }
    },
    // 获取预留签约经销商
    orgquerySearch(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          name: queryString,
          orgType: '50'
        }
      ).then((res, total, code, data) => {
        this.orgresulets = res.map(item => {
          item.orgId = item.orgId + ''
          item.name = item.name + ''
          return item
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 再入职不能早于上一个版本的离职日期
    orgJoinDateabled() {
      if (this.leaveAndJoinLeaveDate !== '' && this.dataForm.orgJoinDate <= this.leaveAndJoinLeaveDate) {
        this.dataForm.orgJoinDate = ''
        this.$alert(
          this.$t(
            'user.leaveDateError', { 'handle': Vue.filter('formatDateNoTime')(this.leaveAndJoinLeaveDate) }
          ), this.$t('prompt.title')
        ).then((res) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
        return false
      }
    },
    // 加入当前公司日期事件
    orgJoinDateChange(val) {
      if (this.leaveAndJoinLeaveDate !== '' && this.dataForm.orgJoinDate <= this.leaveAndJoinLeaveDate) {
        this.dataForm.orgJoinDate = ''
        this.dataForm.jobcodeJoinDate = ''
        this.dataForm.jobcodeJoinDateOne = ''
        this.dataForm.jobcodeJoinDateTwo = ''
        this.$alert(
          this.$t(
            'user.leaveDateError', { 'handle': Vue.filter('formatDateNoTime')(this.leaveAndJoinLeaveDate) }
          ), this.$t('prompt.title')
        ).then((res) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
        return false
      }
      if (this.dataForm.jobCode && this.dataForm.jobCode !== '') {
        this.dataForm.jobcodeJoinDate = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDate = ''
      }
      if (this.dataForm.partTimeJobcodeOne && this.dataForm.partTimeJobcodeOne !== '') {
        this.dataForm.jobcodeJoinDateOne = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDateOne = ''
      }
      if (this.dataForm.partTimeJobcodeTwo && this.dataForm.partTimeJobcodeTwo !== '') {
        this.dataForm.jobcodeJoinDateTwo = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDateTwo = ''
      }
    },
    // 获取角色下拉列表，传递参数：权限分类，同时默认选中内置角色
    changeAuthType: function (val) {
      this.dataForm.roleId = []
      let query = {}
      if (this.dataForm.orgType === '50') {
        query = {
          orgType: '60',
          authType: this.dataForm.authType
        }
      } else {
        query = {
          orgType: this.dataForm.orgType,
          authType: this.dataForm.authType
        }
      }
      this.$request.get(
        '/sys/commuser/sysRoleMT',
        query
      ).then((res, total, code, data) => {
        this.rolelist = res.map(item => {
          item.roleId = item.roleId + ''
          return item
        })
        this.$request.post(
          '/sys/role/queryRoleByType',
          query
        ).then((res, total, code, data) => {
          for (let i = 0; i < res.length; i++) {
            this.dataForm.roleId.push(res[i].roleId + '')
          }
        }).catch((err) => {
          console.log(err)
        })
        if (this.dataForm.orgType === '30') { // 合作院校切换权限分类，清空预签约经销商等信息
          if (this.dataForm.authType === '50') { // Best
            this.dataForm.dealerShipId = ''
            this.dataForm.officialAccountFlag = ''
            this.dataForm.enterSchoolDate = ''
            this.dataForm.leaveSchoolDate = ''
            this.dataForm.graduateStatus = ''
          }
        }
      }).catch((err) => {
        console.log(err)
      })
      // liujx 2021-01-29
      let curOrg = this.dataForm.orgType
      if (curOrg === '50') {
        curOrg = '60'
      }
      let keyOrg = 'APPLY_ORG_TYPE_' + this.dataForm.orgType
      //if (this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)) {
      if (this.dataMap.get(keyOrg)) {
        // this.applyShow = this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)
        this.applyShow = this.dataMap.get(keyOrg)
      }
    },
    // 主要职位职位描述和需要传递给工作流的是否需要TA审批字段
    jobCodeContentChange(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeNum = this.$t('activiti.jobCodeNum')
        this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.refsForm.taApprovalFlag = ''
      } else {
        for (let i = 0; i < this.positionlist.length; i++) {
          if (jobCode === this.positionlist[i].positionCode) {
            this.jobCodeNum = this.$t('activiti.jobCodeNum') + this.positionlist[i].positionCode
            if (this.positionlist[i].positionDesc) {
              this.jobCodeContent = this.$t('activiti.jobCodeNum') + this.positionlist[i].positionCode + '<br/>' + this.$t('activiti.jobCodeContent') + this.positionlist[i].positionDesc.replace(/\n/g, "<br>")
            } else {
              this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
        for (let i = 0; i < this.positionlist.length; i++) {
          if (jobCode === this.positionlist[i].positionCode) {
            this.refsForm.taApprovalFlag = this.positionlist[i].taApprovalFlag
          }
        }
      }
    },
    // 不需要单店单岗判断的主要职位切换，只变更岗位code和岗位描述
    jobChangeNoSingle(jobCode) {
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentChange(jobCode)
    },
    jobLimit(jobCode) {
      if (jobCode) {
        let positionId = ''
        this.positionlist.forEach((item) => {
          if (item.positionCode === jobCode) {
            positionId = item.positionId
          }
        })
        this.isLimitTest(positionId, jobCode)
      }
    },
    // 是否限制测评
    isLimitTest(jobCode, jobCode2) {
      this.$request.post(
        '/acdc/restrict/checkRecruitment',
        {
          jobId: jobCode,
          userId: this.dataForm.userId
        }
      ).then((res) => {
        if (res) {
          if (res.restrictFlag) {
            this.limitShow = true
            this.isLimit = res.restrictFlag
            this.factoryDesc = res.remark
          } else {
            this.jobChange(jobCode2)
          }
        }
      })
    },
    closeLimitModal() {
      this.dataForm.jobCode = ''
      this.factoryDesc = ''
      this.limitShow = false
    },
    // 切换主职位清空所有兼职信息
    jobChange(jobCode) {
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
      this.jobCodeNumOne = this.$t('activiti.jobCodeNum')
      this.jobCodeNumTwo = this.$t('activiti.jobCodeNum')
      this.jobCodeNumThree = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFour = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFive = this.$t('activiti.jobCodeNum')
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.parttimejobList0 = []
      this.parttimejobList1 = []
      this.parttimejobList2 = []
      this.parttimejobList3 = []
      this.parttimejobList4 = []
      this.dataForm.jobcodeJoinDate = ''
      this.dataForm.jobcodeJoinDateOne = ''
      this.dataForm.jobcodeJoinDateTwo = ''
      this.dataForm.jobcodeJoinDateThree = ''
      this.dataForm.jobcodeJoinDateFour = ''
      this.dataForm.jobcodeJoinDateFive = ''
      this.dataForm.partTimeOutletOne = ''
      this.dataForm.partTimeOutletTwo = ''
      this.dataForm.partTimeOutletThree = ''
      this.dataForm.partTimeOutletFour = ''
      this.dataForm.partTimeOutletFive = ''
      this.dataForm.partTimeJobcodeOne = ''
      this.dataForm.partTimeJobcodeTwo = ''
      this.dataForm.partTimeJobcodeThree = ''
      this.dataForm.partTimeJobcodeFour = ''
      this.dataForm.partTimeJobcodeFive = ''
      this.refsForm.taApprovalFlagOne = ''
      this.refsForm.taApprovalFlagTwo = ''
      this.refsForm.taApprovalFlagThree = ''
      this.refsForm.taApprovalFlagFour = ''
      this.refsForm.taApprovalFlagFive = ''
      this.parttimeShow0 = true
      this.parttimeShow1 = true
      this.parttimeShow2 = true
      this.parttimeShow3 = true
      this.parttimeShow4 = true
      this.partOrgShow = true
      if (jobCode && jobCode !== '') {
        this.saved = true
        if (this.dataForm.orgType === '60' || this.dataForm.orgType === '50') {
          this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: jobCode,
              userId: this.dataForm.userId
            }).then((res, total, code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试。'
                this.$alert(message, this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                this.dataForm.jobCode = ''
                this.saved = false
                return false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                this.dataForm.jobCode = ''
                this.saved = false
                return false
              } else if (code === 1 && res > 0) {
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: jobCode,
                    outletId: this.dataForm.orgId,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) { // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.outletArr.find(item => {
                      if (item.orgId === this.dataForm.orgId) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then((res) => {
                      console.log(res)
                    }).catch((err) => {
                      console.log(err)
                    })
                    this.dataForm.jobCode = ''
                    this.saved = false
                    return false
                  } else {
                    this.saved = false
                    // 更改职位描述
                    this.jobCodeContentChange(jobCode)
                    // 兼职网点显示
                    this.partOrgShow = false
                    for (let i = 0; i < this.positionlist.length; i++) {
                      if (jobCode === this.positionlist[i].positionCode) {
                        this.refsForm.taApprovalFlag = this.positionlist[i].taApprovalFlag
                      }
                    }
                    for (let i = 0; i < this.parttimeCheckedList.length; i++) {
                      if (this.dataForm.jobCode === this.parttimeCheckedList[i]) {
                        this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then((res) => {
                          console.log(res)
                        }).catch((err) => {
                          console.log(err)
                        })
                        this.dataForm.jobCode = null
                      }
                    }
                    if (this.jobCodeAll !== '') {
                      if (this.jobCodeAll !== jobCode) {
                        this.dataForm.partTimeJobcodeOne = ''
                        this.dataForm.partTimeJobcodeTwo = ''
                      }
                    }
                    this.jobCodeAll = jobCode
                    if (this.dataForm.jobCode && this.dataForm.jobCode !== '') {
                      this.dataForm.jobcodeJoinDate = this.dataForm.orgJoinDate
                    } else {
                      this.dataForm.jobcodeJoinDate = ''
                    }
                  }
                }).catch((err) => {
                  console.log(err)
                })
              }
            })
        } else {
          this.$request.get('/sys/commuser/singlePosition',
            {
              positionCode: jobCode,
              outletId: this.dataForm.orgId,
              userId: this.dataForm.userId
            }
          ).then((res, total, code, data) => {
            if (res.singlePosition === 1) { // 提示当前岗位单店单岗，已被占用不可选择
              let entry = this.outletArr.find(item => {
                if (item.orgId === this.dataForm.orgId) {
                  return item
                }
              })
              let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
              this.$alert(message, this.$t('prompt.title')).then((res) => {
                console.log(res)
              }).catch((err) => {
                console.log(err)
              })
              this.dataForm.jobCode = ''
              this.saved = false
              return false
            } else {
              this.saved = false
              // 更改职位描述
              this.jobCodeContentChange(jobCode)
              // 兼职网点显示
              this.partOrgShow = false
              for (let i = 0; i < this.positionlist.length; i++) {
                if (jobCode === this.positionlist[i].positionCode) {
                  this.refsForm.taApprovalFlag = this.positionlist[i].taApprovalFlag
                }
              }
              for (let i = 0; i < this.parttimeCheckedList.length; i++) {
                if (this.dataForm.jobCode === this.parttimeCheckedList[i]) {
                  this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then((res) => {
                    console.log(res)
                  }).catch((err) => {
                    console.log(err)
                  })
                  this.dataForm.jobCode = null
                }
              }
              if (this.jobCodeAll !== '') {
                if (this.jobCodeAll !== jobCode) {
                  this.dataForm.partTimeJobcodeOne = ''
                  this.dataForm.partTimeJobcodeTwo = ''
                }
              }
              this.jobCodeAll = jobCode
              if (this.dataForm.jobCode && this.dataForm.jobCode !== '') {
                this.dataForm.jobcodeJoinDate = this.dataForm.orgJoinDate
              } else {
                this.dataForm.jobcodeJoinDate = ''
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    },
    // 变更兼职职位描述
    partTimeJobCodeContentChange(el, key, num) {
      if (el === '' || el === undefined || el === null) {
        this['jobCodeNum' + key] = this.$t('activiti.jobCodeNum')
        this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent')
        this.refsForm['taApprovalFlag' + key] = ''
      } else {
        let parttimejobList = this['parttimejobList' + num]
        for (let i = 0; i < parttimejobList.length; i++) {
          if (el === parttimejobList[i].positionCode) {
            this['jobCodeNum' + key] = this.$t('activiti.jobCodeNum') + parttimejobList[i].positionCode
            if (parttimejobList[i].positionDesc) {
              this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent') + parttimejobList[i].positionDesc
            } else {
              this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent')
            }
            this.refsForm['taApprovalFlag' + key] = parttimejobList[i].taApprovalFlag
          }
        }
      }
    },
    // 兼职不可以重复
    parttimejobRepeat(el, key, num) {
      let _this = this
      _this.isDisable = true
      // 先查询是否为单店单岗
      this.$request.get('/sys/commuser/singlePosition',
        {
          positionCode: this.dataForm['partTimeJobcode' + key],
          outletId: this.dataForm['partTimeOutlet' + key],
          userId: this.dataForm.userId
        }
      ).then((res, total, code, data) => {
        _this.isDisable = false
        this['jobCodeNum' + key] = this.$t('activiti.jobCodeNum')
        this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent')
        this.refsForm['taApprovalFlag' + key] = ''
        if (res.singlePosition === 1) {
          // 提示当前岗位单店单岗，已被占用不可选择
          let entry

          switch(num){
            case 0:
            entry = this.outletArr.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletOne) {
                return item
              }
            })
            break;
            case 1:
             entry = this.outletArr.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletTwo) {
                return item
              }
            })
            break;
            case 2:
            entry = this.outletArr.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletThree) {
                return item
              }
            })
            break;
            case 3:
            entry = this.outletArr.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletFour) {
                return item
              }
            })
            break;
            case 4:
            entry = this.outletArr.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletFive) {
                return item
              }
            })
            break;
          }

          let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
          _this.dataForm['partTimeJobcode' + key] = ''
          _this.dataForm['jobcodeJoinDate' + key] = ''
          return false
        } else {
          //将已添加的网点加职位添加到集合中，用来判断是否重复
          let outletCodeArr = [];
          //添加主职
          outletCodeArr.push(_this.dataForm.orgId+"-"+_this.dataForm.jobCode)
          //添加兼职1
          if(_this.dataForm['partTimeOutletOne']&&_this.dataForm['partTimeJobcodeOne']){
            outletCodeArr.push(_this.dataForm['partTimeOutletOne']+"-"+_this.dataForm['partTimeJobcodeOne'])
          }
          //添加兼职2
          if(_this.dataForm['partTimeOutletTwo']&&_this.dataForm['partTimeJobcodeTwo']){
            outletCodeArr.push(_this.dataForm['partTimeOutletTwo']+"-"+_this.dataForm['partTimeJobcodeTwo'])
          }
          //添加兼职3
          if(_this.dataForm['partTimeOutletThree']&&_this.dataForm['partTimeJobcodeThree']){
            outletCodeArr.push(_this.dataForm['partTimeOutletThree']+"-"+_this.dataForm['partTimeJobcodeThree'])
          }
          //添加兼职4
          if(_this.dataForm['partTimeOutletFour']&&_this.dataForm['partTimeJobcodeFour']){
            outletCodeArr.push(_this.dataForm['partTimeOutletFour']+"-"+_this.dataForm['partTimeJobcodeFour'])
          }
          //添加兼职5
          if(_this.dataForm['partTimeOutletFive']&&_this.dataForm['partTimeJobcodeFive']){
            outletCodeArr.push(_this.dataForm['partTimeOutletFive']+"-"+_this.dataForm['partTimeJobcodeFive'])
          }

          //进行去重
          let uniqueArr = Array.from(new Set(outletCodeArr))

          if(outletCodeArr.length != uniqueArr.length){
             _this.$alert(_this.$t('user.verificationparttime'), _this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                _this.dataForm['partTimeJobcode' + key] = ''
                _this.dataForm['jobcodeJoinDate' + key] = ''
                _this.dataForm['jobcodeLeaveDate' + key] = ''
                return false
          }

            _this.dataForm['jobcodeJoinDate' + key] = _this.dataForm.orgJoinDate
            this.partTimeJobCodeContentChange(el, key, num)
        }
      }).catch((err) => {
        console.log(err)
      _this.isDisable = false
      })
    },
    getOrgArr(orgType, orgId, parentOrgId) {
      let id = orgId
      if (orgType === '60') {
        id = parentOrgId
      }
      this.$request.get(`/sys/org/info/${id}`).then((res, total, code, data) => {
        this.orgArr = []
        this.orgArr.push(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取经销商网点下拉
    getOutletArr(orgId) {
      this.$request.get('/sys/org/queryNet/' + orgId).then((res, total, code, data) => {
        this.outletArr = res
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取bbano等信息
    orgIdChange: function (value) {
      // 清空主要职位，兼职，直线经理，只保留一个兼职岗位显示在页面上
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
      this.jobCodeNumOne = this.$t('activiti.jobCodeNum')
      this.jobCodeNumTwo = this.$t('activiti.jobCodeNum')
      this.jobCodeNumThree = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFour = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFive = this.$t('activiti.jobCodeNum')
      this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
      this.dataForm.jobCode = ''
      this.dataForm.jobcodeJoinDate = ''
      this.parttimejobList0 = []
      this.parttimejobList1 = []
      this.parttimejobList2 = []
      this.parttimejobList3 = []
      this.parttimejobList4 = []
      this.dataForm.partTimeOutletOne = ''
      this.dataForm.partTimeOutletTwo = ''
      this.dataForm.partTimeOutletThree = ''
      this.dataForm.partTimeOutletFour = ''
      this.dataForm.partTimeOutletFive = ''
      this.dataForm.partTimeJobcodeOne = ''
      this.dataForm.partTimeJobcodeTwo = ''
      this.dataForm.partTimeJobcodeThree = ''
      this.dataForm.partTimeJobcodeFour = ''
      this.dataForm.partTimeJobcodeFive = ''
      this.dataForm.jobcodeJoinDateOne = ''
      this.dataForm.jobcodeJoinDateTwo = ''
      this.dataForm.jobcodeJoinDateThree = ''
      this.dataForm.jobcodeJoinDateFour = ''
      this.dataForm.jobcodeJoinDateFive = ''
      this.refsForm.taApprovalFlagOne = ''
      this.refsForm.taApprovalFlagTwo = ''
      this.refsForm.taApprovalFlagThree = ''
      this.refsForm.taApprovalFlagFour = ''
      this.refsForm.taApprovalFlagFive = ''
      this.partOrgShow = true
      this.parttimeShow0 = true
      this.parttimeShow1 = true
      this.parttimeShow2 = true
      this.parttimeShow3 = true
      this.parttimeShow4 = true
      this.parttimeCheckedList = [null, null, null, null]
      this.positionlist = []
      if (value !== null) {
        this.$request.post('/sys/commuser/commPositionByParam',
          {
            orgType: '60',
            orgId: value
          }
        ).then((res, total, code, data) => {
          this.positionlist = res
        }).catch((err) => {
          console.log(err)
        })
        for (let i = 0; i < this.outletArr.length; i++) {
          if (value === this.outletArr[i].orgId) {
            this.dataForm.bbaNo = this.outletArr[i].bbaNo
            this.dataForm.nscNo = this.outletArr[i].nscNo
            this.dataForm.brandCode = Vue.filter('coverEnumList')(this.outletArr[i].brandCodes, 'brandCode', ',')
            this.dataForm.outletType = Vue.filter('coverEnum')(this.outletArr[i].networkType, 'networkType')
          }
        }
        this.jobCodeshow = false
      } else {
        this.jobCodeshow = true
        this.dataForm.bbaNo = ''
        this.dataForm.nscNo = ''
        this.dataForm.brandCode = ''
        this.dataForm.outletType = ''
      }
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate('jobCode')
      })
    },
    // 选取兼职网点时
    partOrgChange(orgId, index) {
      if (index === 0) {
        this.jobCodeNumOne = this.$t('activiti.jobCodeNum')
        this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
        this.refsForm.taApprovalFlagOne = ''
      } else if (index === 1) {
        this.jobCodeNumTwo = this.$t('activiti.jobCodeNum')
        this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
        this.refsForm.taApprovalFlagTwo = ''
      }else if (index === 2) {
        this.jobCodeNumThree = this.$t('activiti.jobCodeNum')
        this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
        this.refsForm.taApprovalFlagThree = ''
      }else if (index === 3) {
        this.jobCodeNumFour = this.$t('activiti.jobCodeNum')
        this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
        this.refsForm.taApprovalFlagFour = ''
      }else if (index === 4) {
        this.jobCodeNumFive = this.$t('activiti.jobCodeNum')
        this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
        this.refsForm.taApprovalFlagFive = ''
      }
      if (orgId !== '' && orgId !== undefined && orgId !== null) {
        this['parttimeShow' + index] = false
        this.$request.post('/sys/commuser/commPositionTimeJob',
          {
            positionCode: this.dataForm.jobCode,
            orgId: orgId
          }).then((res, total, code, data) => {
            if (res && res.length < 1) {
              this.$alert(this.$t('user.hasNoPartTime'), this.$t('prompt.title')).then(() => {
                if (index === 0) {
                  this.dataForm.partTimeOutletOne = ''
                }
                if (index === 1) {
                  this.dataForm.partTimeOutletTwo = ''
                }
                if (index === 2) {
                  this.dataForm.partTimeOutletThree = ''
                }
                if (index === 3) {
                  this.dataForm.partTimeOutletFour = ''
                }
                if (index === 4) {
                  this.dataForm.partTimeOutletFive = ''
                }
              }).catch((err) => {
                console.log(err)
              })
            }
            this['parttimejobList' + index] = res
          }).catch((err) => {
            console.log(err)
          })
      } else {
        this['parttimeShow' + index] = true
        if (index === 0) {
          this.dataForm.jobcodeJoinDateOne = ''
        }
        if (index === 1) {
          this.dataForm.jobcodeJoinDateTwo = ''
        }
        if (index === 2) {
          this.dataForm.jobcodeJoinDateThree = ''
        }
        if (index === 3) {
          this.dataForm.jobcodeJoinDateFour = ''
        }
        if (index === 4) {
          this.dataForm.jobcodeJoinDateFive = ''
        }
      }
      if (index === 0) {
        this.dataForm.partTimeJobcodeOne = ''
      }
      if (index === 1) {
        this.dataForm.partTimeJobcodeTwo = ''
      }
      if (index === 2) {
        this.dataForm.partTimeJobcodeThree = ''
      }
      if (index === 3) {
        this.dataForm.partTimeJobcodeFour = ''
      }
      if (index === 4) {
        this.dataForm.partTimeJobcodeFive = ''
      }
    },
    // 获取兼职1职位list
    queryJobPart0(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletOne,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList0 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职2职位list
    queryJobPart1(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletTwo,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList1 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职3职位list
    queryJobPart2(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletThree,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList2 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职4职位list
    queryJobPart3(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletFour,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList3 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职5职位list
    queryJobPart4(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletFive,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList4 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取信息 userRole hradminAudit 第一步审批 areaAudit 第二步审批
    getInfo() {
      let userId = this.dataForm.userId
      if (!isNaN(parseInt(userId, 10))) {
        const base64url = require('base64-url')
        let aes = new AesUtil()
        userId = base64url.encode(aes.encrypt(this.dataForm.userId + ''))
      }
      this.$request.get(`/sys/commuser/infomt/${userId}`).then((res, total, code, data) => {
        res.bbaNo = ''
        res.nscNo = ''
        res.brandCode = ''
        res.jobcodeAge = ''
        if (res.birthday !== '' && res.birthday !== null) {
          res.birthday = Vue.filter('formatDateNoTime')(res.birthday)
        }
        if (res.privacyFileUrl && res.privacyFileUrl !== '') {
          this.privacyFileUrl = res.uploadHost + res.privacyFileUrl
        } else {
          this.privacyFileUrl = ''
        }
        if (res.userHistoryEntityList && res.userHistoryEntityList instanceof Array && res.userHistoryEntityList.length > 0) {
          this.leaveAndJoinLeaveDate = res.userHistoryEntityList[res.userHistoryEntityList.length - 1].leaveDate
        }
        this.oldDataForm = JSON.parse(JSON.stringify(res))
        if (this.approval !== 0 && this.approval !== '0' && res.bmwSeniority !== null && res.bmwSeniority !== undefined) {
          res.bmwSeniority = (res.bmwSeniority / 365).toFixed(2)
        }
        this.getOrgArr(res.orgType, res.orgId, res.parentOrgId)
        if (res.roleId !== '' && res.roleId) {
          res.roleId = res.roleId.split(',')
        } else {
          res.roleId = []
        }

        this.$request.get(`/sys/config/acquireOrgTypeSetting`).then((res, total, code, data) => {
            this.dataMap = new Map()
            for (let i = 0; i < res.length; i++) {
              this.dataMap.set(res[i].paramKey, res[i].paramValue)
            }
            let orgTypeChar = this.dataForm.orgType
            if (orgTypeChar === '50') {
              orgTypeChar = '60'
            }
            let keyType = 'APPLY_ORG_TYPE_' + orgTypeChar
            //if (this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)) {
            if (this.dataMap.get(keyType)) {
              this.applyShow = this.dataMap.get(keyType)
            }
        }).catch((err) => {
          console.log(err)
        })



        if (this.userRole === 'hradminAudit') { // 第一个审批人
          if (res.orgType === '60') { // 经销商二级审批打回一级审批
            if (res.parentOrgId && res.parentOrgId !== '') {
              this.$request.get('/sys/org/queryNet/' + res.parentOrgId).then((res, total, code, data) => {
                this.outletArr = res
                if (this.dataForm.orgId || this.dataForm.orgId !== '') {
                  for (let i = 0; i < this.outletArr.length; i++) {
                    if (this.dataForm.orgId === this.outletArr[i].orgId) {
                      this.dataForm.bbaNo = this.outletArr[i].bbaNo
                      this.dataForm.nscNo = this.outletArr[i].nscNo
                      this.dataForm.brandCode = Vue.filter('coverEnumList')(this.outletArr[i].brandCodes, 'brandCode', ',')
                      this.dataForm.outletType = Vue.filter('coverEnum')(this.outletArr[i].networkType, 'networkType')
                    }
                  }
                }
              }).catch((err) => {
                console.log(err)
              })

              // this.getOutletArr(res.parentOrgId)
              this.parentOrgId = res.parentOrgId
              this.dataForm = {
                ...this.dataForm,
                ...res
              }
              // 2022/2/23 如果Activiti的历史数据存在，那么把用户信息的最新信息替换为activiti的流程时信息
              if (this.actHistoryApplicantData.jobCode && this.actHistoryApplicantData.jobCode !== '') {
                this.dataForm.orgId = this.actHistoryApplicantData.orgId
                this.dataForm.partTimeOutletOne = this.actHistoryApplicantData.partTimeOutletOne
                this.dataForm.partTimeOutletTwo = this.actHistoryApplicantData.partTimeOutletTwo
                this.dataForm.partTimeOutletThree = this.actHistoryApplicantData.partTimeOutletThree
                this.dataForm.partTimeOutletFour = this.actHistoryApplicantData.partTimeOutletFour
                this.dataForm.partTimeOutletFive = this.actHistoryApplicantData.partTimeOutletFive

                this.dataForm.jobCode = this.actHistoryApplicantData.jobCode
                this.dataForm.partTimeJobcodeOne = this.actHistoryApplicantData.partTimeJobcodeOne
                this.dataForm.partTimeJobcodeTwo = this.actHistoryApplicantData.partTimeJobcodeTwo
                this.dataForm.partTimeJobcodeThree = this.actHistoryApplicantData.partTimeJobcodeThree
                this.dataForm.partTimeJobcodeFour = this.actHistoryApplicantData.partTimeJobcodeFour
                this.dataForm.partTimeJobcodeFive = this.actHistoryApplicantData.partTimeJobcodeFive

                this.dataForm.jobcodeJoinDate = this.actHistoryApplicantData.jobcodeJoinDate
                this.dataForm.jobcodeJoinDateOne = this.actHistoryApplicantData.jobcodeJoinDateOne
                this.dataForm.jobcodeJoinDateTwo = this.actHistoryApplicantData.jobcodeJoinDateTwo
                this.dataForm.jobcodeJoinDateThree = this.actHistoryApplicantData.jobcodeJoinDateThree
                this.dataForm.jobcodeJoinDateFour = this.actHistoryApplicantData.jobcodeJoinDateFour
                this.dataForm.jobcodeJoinDateFive = this.actHistoryApplicantData.jobcodeJoinDateFive

                console.log("***************************工作流存储数据存在已设定为工作流数据orgType:60")
              }


              // 判断是否可编辑
              if (this.dataForm.jobCode && this.dataForm.jobCode !== '') {
                this.jobCodeshow = false
                this.partOrgShow = false
              }
              if (this.dataForm.partTimeJobcodeOne && this.dataForm.partTimeJobcodeOne !== '') {
                this.parttimeShow0 = false
              }
              if (this.dataForm.partTimeJobcodeTwo && this.dataForm.partTimeJobcodeTwo !== '') {
                this.parttimeShow1 = false
              }
              if (this.dataForm.partTimeJobcodeThree && this.dataForm.partTimeJobcodeThree !== '') {
                this.parttimeShow2 = false
              }
              if (this.dataForm.partTimeJobcodeFour && this.dataForm.partTimeJobcodeFour !== '') {
                this.parttimeShow3 = false
              }
              if (this.dataForm.partTimeJobcodeFive && this.dataForm.partTimeJobcodeFive !== '') {
                this.parttimeShow4 = false
              }
              // 根据jobCode回显主职
              this.$request.get(
                `/sys/commuser/selectPositionByCode`,
                {
                  positionCode: this.dataForm.jobCode
                }
              ).then((res, total, code, data) => {
                this.positionlist = res
                if (this.dataForm.jobCode === undefined || this.dataForm.jobCode === '' || this.dataForm.jobCode === null) {
                  this.jobCodeNum = this.$t('activiti.jobCodeNum')
                  this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
                  this.refsForm.taApprovalFlag = ''
                } else {
                  this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc
                  } else {
                    this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                  this.refsForm.taApprovalFlag = res[0].taApprovalFlag
                }
              }).catch((err) => {
                console.log(err)
              })
              if (this.dataForm.authType && this.dataForm.authType !== '') {
                this.$request.get(
                  `/sys/commuser/sysRoleMT`,
                  {
                    orgType: this.dataForm.orgType,
                    authType: this.dataForm.authType
                  }
                ).then((res, total, code, data) => {
                  this.rolelist = res.map(item => {
                    item.roleId = item.roleId + ''
                    return item
                  })
                }).catch((err) => {
                  console.log(err)
                })
              } else {
                this.dataForm.roleId = []
              }
              if (this.dataForm.partTimeJobcodeOne && this.dataForm.partTimeJobcodeOne !== '') {
                // 兼职1职位回显
                this.$request.get(`/sys/commuser/selectPositionByCode`,
                  {
                    positionCode: this.dataForm.partTimeJobcodeOne
                  }
                ).then((res, total, code, data) => {
                  this.parttimejobList0 = res
                  this.jobCodeNumOne = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent') + '<br/>' + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                  this.refsForm.taApprovalFlagOne = res[0].taApprovalFlag
                }).catch((err) => {
                  console.log(err)
                })
              }
              if (this.dataForm.partTimeJobcodeTwo && this.dataForm.partTimeJobcodeTwo !== '') {
                // 兼职2职位回显
                this.$request.get(`/sys/commuser/selectPositionByCode`,
                  {
                    positionCode: this.dataForm.partTimeJobcodeTwo
                  }
                ).then((res, total, code, data) => {
                  this.parttimejobList1 = res
                  this.jobCodeNumTwo = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                  this.refsForm.taApprovalFlagTwo = res[0].taApprovalFlag
                }).catch((err) => {
                  console.log(err)
                })
              }
              if (this.dataForm.partTimeJobcodeThree && this.dataForm.partTimeJobcodeThree !== '') {
                // 兼职3职位回显
                this.$request.get(`/sys/commuser/selectPositionByCode`,
                  {
                    positionCode: this.dataForm.partTimeJobcodeThree
                  }
                ).then((res, total, code, data) => {
                  this.parttimejobList2 = res
                  this.jobCodeNumThree = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                  this.refsForm.taApprovalFlagThree = res[0].taApprovalFlag
                }).catch((err) => {
                  console.log(err)
                })
              }
              if (this.dataForm.partTimeJobcodeFour && this.dataForm.partTimeJobcodeFour !== '') {
                // 兼职4职位回显
                this.$request.get(`/sys/commuser/selectPositionByCode`,
                  {
                    positionCode: this.dataForm.partTimeJobcodeFour
                  }
                ).then((res, total, code, data) => {
                  this.parttimejobList3 = res
                  this.jobCodeNumFour = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                  this.refsForm.taApprovalFlagFour = res[0].taApprovalFlag
                }).catch((err) => {
                  console.log(err)
                })
              }
              if (this.dataForm.partTimeJobcodeFive && this.dataForm.partTimeJobcodeFive !== '') {
                // 兼职5职位回显
                this.$request.get(`/sys/commuser/selectPositionByCode`,
                  {
                    positionCode: this.dataForm.partTimeJobcodeFive
                  }
                ).then((res, total, code, data) => {
                  this.parttimejobList4 = res
                  this.jobCodeNumFive = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                  this.refsForm.taApprovalFlagFive = res[0].taApprovalFlag
                }).catch((err) => {
                  console.log(err)
                })
              }
            }
          } else if (res.orgType === '50') { // 经销商网点
            this.getOutletArr(res.orgId)
            this.parentOrgId = res.orgId
            res.orgId = ''
            res.authType = ''
            this.dataForm = {
              ...this.dataForm,
              ...res
            }
            // 2022/2/23 如果Activiti的历史数据存在，那么把用户信息的最新信息替换为activiti的流程时信息
            if (this.actHistoryApplicantData.jobCode && this.actHistoryApplicantData.jobCode !== '') {
              this.dataForm.orgId = this.actHistoryApplicantData.orgId
              this.dataForm.partTimeOutletOne = this.actHistoryApplicantData.partTimeOutletOne
              this.dataForm.partTimeOutletTwo = this.actHistoryApplicantData.partTimeOutletTwo
              this.dataForm.partTimeOutletThree = this.actHistoryApplicantData.partTimeOutletThree
              this.dataForm.partTimeOutletFour = this.actHistoryApplicantData.partTimeOutletFour
              this.dataForm.partTimeOutletFive = this.actHistoryApplicantData.partTimeOutletFive

              this.dataForm.jobCode = this.actHistoryApplicantData.jobCode
              this.dataForm.partTimeJobcodeOne = this.actHistoryApplicantData.partTimeJobcodeOne
              this.dataForm.partTimeJobcodeTwo = this.actHistoryApplicantData.partTimeJobcodeTwo
              this.dataForm.partTimeJobcodeThree = this.actHistoryApplicantData.partTimeJobcodeThree
              this.dataForm.partTimeJobcodeFour = this.actHistoryApplicantData.partTimeJobcodeFour
              this.dataForm.partTimeJobcodeFive = this.actHistoryApplicantData.partTimeJobcodeFive

              this.dataForm.jobcodeJoinDate = this.actHistoryApplicantData.jobcodeJoinDate
              this.dataForm.jobcodeJoinDateOne = this.actHistoryApplicantData.jobcodeJoinDateOne
              this.dataForm.jobcodeJoinDateTwo = this.actHistoryApplicantData.jobcodeJoinDateTwo
              this.dataForm.jobcodeJoinDateThree = this.actHistoryApplicantData.jobcodeJoinDateThree
              this.dataForm.jobcodeJoinDateFour = this.actHistoryApplicantData.jobcodeJoinDateFour
              this.dataForm.jobcodeJoinDateFive = this.actHistoryApplicantData.jobcodeJoinDateFive

              console.log("***************************工作流存储数据存在已设定为工作流数据orgType:50")
            }


            this.dataForm.roleId = []
          } else if (res.orgType === '40' || res.orgType === '30' || res.orgType === '20' || res.orgType === '10') { // 经销商集团 合作院校 合作伙伴 宝马集团
            this.dataForm = {
              ...this.dataForm,
              ...res
            }
            // 2022/2/23 如果Activiti的历史数据存在，那么把用户信息的最新信息替换为activiti的流程时信息
            if (this.actHistoryApplicantData.jobCode && this.actHistoryApplicantData.jobCode !== '') {
              this.dataForm.orgId = this.actHistoryApplicantData.orgId
              this.dataForm.partTimeOutletOne = this.actHistoryApplicantData.partTimeOutletOne
              this.dataForm.partTimeOutletTwo = this.actHistoryApplicantData.partTimeOutletTwo
              this.dataForm.partTimeOutletThree = this.actHistoryApplicantData.partTimeOutletThree
              this.dataForm.partTimeOutletFour = this.actHistoryApplicantData.partTimeOutletFour
              this.dataForm.partTimeOutletFive = this.actHistoryApplicantData.partTimeOutletFive

              this.dataForm.jobCode = this.actHistoryApplicantData.jobCode
              this.dataForm.partTimeJobcodeOne = this.actHistoryApplicantData.partTimeJobcodeOne
              this.dataForm.partTimeJobcodeTwo = this.actHistoryApplicantData.partTimeJobcodeTwo
              this.dataForm.partTimeJobcodeThree = this.actHistoryApplicantData.partTimeJobcodeThree
              this.dataForm.partTimeJobcodeFour = this.actHistoryApplicantData.partTimeJobcodeFour
              this.dataForm.partTimeJobcodeFive = this.actHistoryApplicantData.partTimeJobcodeFive

              this.dataForm.jobcodeJoinDate = this.actHistoryApplicantData.jobcodeJoinDate
              this.dataForm.jobcodeJoinDateOne = this.actHistoryApplicantData.jobcodeJoinDateOne
              this.dataForm.jobcodeJoinDateTwo = this.actHistoryApplicantData.jobcodeJoinDateTwo
              this.dataForm.jobcodeJoinDateThree = this.actHistoryApplicantData.jobcodeJoinDateThree
              this.dataForm.jobcodeJoinDateFour = this.actHistoryApplicantData.jobcodeJoinDateFour
              this.dataForm.jobcodeJoinDateFive = this.actHistoryApplicantData.jobcodeJoinDateFive

              console.log("***************************工作流存储数据存在已设定为工作流数据orgType:10,20,30,40")
            }
            // 如果有已选预签约，下拉列表只显示当前选项，因为输入下拉的列表默认只显示10个，可能无法正常回显
            if (this.dataForm.dealerShipId && this.dataForm.dealerShipId !== '') {
              this.$request.get(`/sys/org/info/${this.dataForm.dealerShipId}`).then((res, total, code, data) => {
                this.orgresulets = []
                this.orgresulets.push(res)
              }).catch((err) => {
                console.log(err)
              })
            }
            if (this.dataForm.jobCode && this.dataForm.jobCode !== '') {
              // 根据jobCode回显主职
              this.$request.get(
                `/sys/commuser/selectPositionByCode`,
                {
                  positionCode: this.dataForm.jobCode
                }
              ).then((res, total, code, data) => {
                this.positionlist = res
                if (this.dataForm.jobCode === '' || this.dataForm.jobCode === undefined || this.dataForm.jobCode === null) {
                  this.jobCodeNum = this.$t('activiti.jobCodeNum')
                  this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
                  this.refsForm.taApprovalFlag = ''
                } else {
                  this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br>")
                  } else {
                    this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                  this.refsForm.taApprovalFlag = res[0].taApprovalFlag
                }
              }).catch((err) => {
                console.log(err)
              })
            } else {
              // 根据jobCode回显主职 获取默认10个主要职位下拉列表
              this.$request.post(
                `/sys/commuser/commPositionByParam`,
                {
                  orgType: this.dataForm.orgType
                }
              ).then((res, total, code, data) => {
                this.positionlist = res
                if (this.dataForm.jobCode === '' || this.dataForm.jobCode === undefined || this.dataForm.jobCode === null) {
                  this.jobCodeNum = this.$t('activiti.jobCodeNum')
                  this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
                } else {
                  this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                }
              }).catch((err) => {
                console.log(err)
              })
            }
            if (this.dataForm.authType && this.dataForm.authType !== '') {
              this.$request.get(
                '/sys/commuser/sysRoleMT',
                {
                  orgType: this.dataForm.orgType,
                  authType: this.dataForm.authType
                }
              ).then((res, total, code, data) => {
                this.rolelist = res.map(item => {
                  item.roleId = item.roleId + ''
                  return item
                })
              }).catch((err) => {
                console.log(err)
              })
            } else {
              this.dataForm.roleId = []
            }
          }
          // 手动清空检验，否则角色会直接校验是否为空
          this.$nextTick(function () {
            this.$refs['dataForm'].clearValidate()
          })
        } else if (this.userRole === 'areaAudit' || this.userRole === 'areaManagerAudit') {
          this.dataForm = {
            ...this.dataForm,
            ...res
          }
          // 2022/2/23 如果Activiti的历史数据存在，那么把用户信息的最新信息替换为activiti的流程时信息
          if (this.actHistoryApplicantData.jobCode && this.actHistoryApplicantData.jobCode !== '') {
            this.dataForm.orgId = this.actHistoryApplicantData.orgId
            this.dataForm.partTimeOutletOne = this.actHistoryApplicantData.partTimeOutletOne
            this.dataForm.partTimeOutletTwo = this.actHistoryApplicantData.partTimeOutletTwo
            this.dataForm.partTimeOutletThree = this.actHistoryApplicantData.partTimeOutletThree
            this.dataForm.partTimeOutletFour = this.actHistoryApplicantData.partTimeOutletFour
            this.dataForm.partTimeOutletFive = this.actHistoryApplicantData.partTimeOutletFive

            this.dataForm.jobCode = this.actHistoryApplicantData.jobCode
            this.dataForm.partTimeJobcodeOne = this.actHistoryApplicantData.partTimeJobcodeOne
            this.dataForm.partTimeJobcodeTwo = this.actHistoryApplicantData.partTimeJobcodeTwo
            this.dataForm.partTimeJobcodeThree = this.actHistoryApplicantData.partTimeJobcodeThree
            this.dataForm.partTimeJobcodeFour = this.actHistoryApplicantData.partTimeJobcodeFour
            this.dataForm.partTimeJobcodeFive = this.actHistoryApplicantData.partTimeJobcodeFive

            this.dataForm.jobcodeJoinDate = this.actHistoryApplicantData.jobcodeJoinDate
            this.dataForm.jobcodeJoinDateOne = this.actHistoryApplicantData.jobcodeJoinDateOne
            this.dataForm.jobcodeJoinDateTwo = this.actHistoryApplicantData.jobcodeJoinDateTwo
            this.dataForm.jobcodeJoinDateThree = this.actHistoryApplicantData.jobcodeJoinDateThree
            this.dataForm.jobcodeJoinDateFour = this.actHistoryApplicantData.jobcodeJoinDateFour
            this.dataForm.jobcodeJoinDateFive = this.actHistoryApplicantData.jobcodeJoinDateFive

            console.log("***************************工作流存储数据存在已设定为工作流数据areaManagerAuditORareaAudit")
          }
          // 根据jobCode回显主职
          this.$request.get(
            `/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.jobCode
            }
          ).then((res, total, code, data) => {
            this.positionlist = res
            if (this.dataForm.jobCode === '' || this.dataForm.jobCode === undefined || this.dataForm.jobCode === null) {
              this.jobCodeNum = this.$t('activiti.jobCodeNum')
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
            } else {
              this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }
          }).catch((err) => {
            console.log(err)
          })
          // 赋值网点类型
          // this.dataForm.outletType = Vue.filter('coverEnumList')(this.dataForm.networkType, 'networkType', ',')
          // 如果有已选预签约，下拉列表只显示当前选项，因为输入下拉的列表默认只显示10个，可能无法正常回显
          if (this.dataForm.dealerShipId && this.dataForm.dealerShipId !== '') {
            this.$request.get(`/sys/org/info/${this.dataForm.dealerShipId}`).then((res, total, code, data) => {
              this.orgresulets = []
              this.orgresulets.push(res)
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.dataForm.authType && this.dataForm.authType !== '') {
            this.$request.get(
              `/sys/commuser/sysRoleMT`,
              {
                orgType: this.dataForm.orgType,
                authType: this.dataForm.authType
              }
            ).then((res, total, code, data) => {
              this.rolelist = res.map(item => {
                item.roleId = item.roleId + ''
                return item
              })
            }).catch((err) => {
              console.log(err)
            })
          } else {
            this.dataForm.roleId = []
          }
          if (res.orgType === '60') { // 经销商
            if (res.parentOrgId) {
              this.$request.get('/sys/org/queryNet/' + res.parentOrgId).then((res, total, code, data) => {
                this.outletArr = res
                if (this.dataForm.orgId || this.dataForm.orgId !== '') {
                  for (let i = 0; i < this.outletArr.length; i++) {
                    if (this.dataForm.orgId === this.outletArr[i].orgId) {
                      this.dataForm.bbaNo = this.outletArr[i].bbaNo
                      this.dataForm.nscNo = this.outletArr[i].nscNo
                      this.dataForm.brandCode = Vue.filter('coverEnumList')(this.outletArr[i].brandCodes, 'brandCode', ',')
                      this.dataForm.outletType = Vue.filter('coverEnum')(this.outletArr[i].networkType, 'networkType')
                    }
                  }
                }
              }).catch((err) => {
                console.log(err)
              })
              // this.getOutletArr(res.parentOrgId)
              this.parentOrgId = res.parentOrgId
            }
            if (this.dataForm.partTimeJobcodeOne && this.dataForm.partTimeJobcodeOne !== '') {
              // 兼职1职位回显
              this.$request.get(`/sys/commuser/selectPositionByCode`,
                {
                  positionCode: this.dataForm.partTimeJobcodeOne
                }).then((res, total, code, data) => {
                  this.parttimejobList0 = res
                  this.jobCodeNumOne = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent') + '<br/>' + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                }).catch((err) => {
                  console.log(err)
                })
            }
            if (this.dataForm.partTimeJobcodeTwo && this.dataForm.partTimeJobcodeTwo !== '') {
              // 兼职2职位回显
              this.$request.get(`/sys/commuser/selectPositionByCode`,
                {
                  positionCode: this.dataForm.partTimeJobcodeTwo
                }).then((res, total, code, data) => {
                  this.parttimejobList1 = res
                  this.jobCodeNumTwo = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                }).catch((err) => {
                  console.log(err)
                })
            }
            if (this.dataForm.partTimeJobcodeThree && this.dataForm.partTimeJobcodeThree !== '') {
              // 兼职3职位回显
              this.$request.get(`/sys/commuser/selectPositionByCode`,
                {
                  positionCode: this.dataForm.partTimeJobcodeThree
                }).then((res, total, code, data) => {
                  this.parttimejobList2 = res
                  this.jobCodeNumThree = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                }).catch((err) => {
                  console.log(err)
                })
            }
            if (this.dataForm.partTimeJobcodeFour && this.dataForm.partTimeJobcodeFour !== '') {
              // 兼职4职位回显
              this.$request.get(`/sys/commuser/selectPositionByCode`,
                {
                  positionCode: this.dataForm.partTimeJobcodeFour
                }).then((res, total, code, data) => {
                  this.parttimejobList3 = res
                  this.jobCodeNumFour = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                }).catch((err) => {
                  console.log(err)
                })
            }
            if (this.dataForm.partTimeJobcodeFive && this.dataForm.partTimeJobcodeFive !== '') {
              // 兼职5职位回显
              this.$request.get(`/sys/commuser/selectPositionByCode`,
                {
                  positionCode: this.dataForm.partTimeJobcodeFive
                }).then((res, total, code, data) => {
                  this.parttimejobList4 = res
                  this.jobCodeNumFive = this.$t('activiti.jobCodeNum') + res[0].positionCode
                  if (res[0].positionDesc) {
                    this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                  } else {
                    this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
                  }
                }).catch((err) => {
                  console.log(err)
                })
            }
          } else if (res.orgType === '50') { // 经销商网点
            this.getOutletArr(this.dataForm.orgId)
            this.parentOrgId = this.dataForm.orgId
            this.dataForm.orgId = ''
            this.dataForm.roleId = []
          } else if (res.orgType === '40' || res.orgType === '30' || res.orgType === '20' || res.orgType === '10') { // 经销商集团 合作院校 合作伙伴 宝马集团

          }
        }
        // 已办且审批通过需要计算宝龄和岗龄
        if (this.approval === 0 || this.approval === '0') {
          if (this.dataForm.registrationApprovaStatus === '50') {
            // 算岗龄
            let joinDate = Vue.filter('theTime')(this.dataForm.jobcodeJoinDate)
            if (!this.dataForm.jobcodeJoinDate) {
              joinDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
            }
            let now = Date.parse(new Date())
            if (this.dataForm.jobStatus === '20') {
              if (this.dataForm.leaveDate && this.dataForm.leaveDate !== '') {
                now = Vue.filter('theTime')(this.dataForm.leaveDate)
              }
            }
            // 时间差
            let dateDeviation = parseInt(Math.abs(now - joinDate) / 1000 / 60 / 60 / 24, 10)
            this.dataForm.jobcodeAge = dateDeviation
            // 计算宝龄
            let currentVersionDate = 0
            let bmwDateDeviation = 0
            // 如果在职
            if (this.dataForm.jobStatus === '10') {
              if (this.dataForm.currentVersionDate) {
                currentVersionDate = Vue.filter('theTime')(this.dataForm.currentVersionDate)
                bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
              } else {
                if (this.dataForm.orgJoinDate) {
                  currentVersionDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
                  bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
                }
              }
              this.dataForm.bmwSeniority = bmwDateDeviation + Number(this.dataForm.bmwSeniority)
            }
            this.dataForm.bmwSeniority = (this.dataForm.bmwSeniority / 365).toFixed(2)
          } else {
            if (this.dataForm.bmwSeniority !== null && this.dataForm.bmwSeniority !== undefined) {
              this.dataForm.bmwSeniority = (this.dataForm.bmwSeniority / 365).toFixed(2)
            }
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    downloadFile() {
      if (this.dataForm.fileName === '' || this.dataForm.fileName === null || this.dataForm.fileName === undefined) {
        this.$message({
          message: '请先上传文件',
          type: 'error',
          duration: 1500,
        })
      } else {
        this.$message({
          message: this.$t('user.authApplyDownloadFileMessage'),
          type: 'info',
          duration: 1000,
        })
        this.$request.downloadBigFile('/sys/commAdminFileManagement/downloadUploadedFile',
        // this.$request.download('/sys/commAdminFileManagement/downloadFile',
          this.dataForm.fileName,
          {
            fileManagementId: this.dataForm.fileManagementId
          },
          null,
          true
        )
      }
    },
    downloadTemplate() {
      this.$request.download('/sys/commAdminFileManagement/downloadTemplate',
              this.templeteFileName, // '管理员资质模板.xlsx',
        {

        },
        null,
        true
      )
    },
    // 获取主要岗位下拉列表
    getPositionInfo(val) {
      this.$request.post('/sys/commuser/commPositionByParam', {
        orgType: this.dataForm.orgType,
        orgId: val
      }).then((res, total, code, data) => {
        this.positionlist = res
        if (this.dataForm.jobCode) {
          this.jobCodeContentChange(this.dataForm.jobCode)
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    handlePreview(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      console.log(file)
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      //  this.fileList = []
      if (response.code !== 1) {
        this.$message({
          message: response.msg,
          type: 'error',
          duration: 1500,
        })
      } else {
        this.$message({
          message: '上传成功',
          type: 'success',
          duration: 1500,
        })
      }
      this.dataForm.fileManagementId = response.data.fileManagementId
      this.dataForm.fileName = response.data.fileName
      this.dataForm.filePath = response.data.filePath
      this.$forceUpdate()
    },
    beforeExcelUpload(file, fileList) {
      if (file == null) {
        this.$message({
          message: '请先上传文件',
          type: 'error',
          duration: 1500,
          // onClose: () => {
          //     this.getDataList()
          // }
        })
        return false
      }
      let maxLength = 20 * 1024 * 1024
      if (file.size > maxLength) {
        this.$message({
          message: '文件大小不能超过20M',
          type: 'error',
          duration: 1500,
        })
        return false
      }
      let fullName = file.name
      let idx = fullName.lastIndexOf(".")
      let extName = fullName.substr(idx + 1);
      extName = extName.toUpperCase()
      let includeExt = new Array('PDF','JPG','JPEG','PNG','BMP') // ('PDF','JPG','JPEG','PNG','PBG','GIF','BMP')
      if (includeExt.indexOf(extName) < 0) {
        this.$message({
          message: this.$t('authApply.fileFormatMsg'),  // '请上传PDF格式或图片格式文件',
          type: 'error',
          duration: 1500,
        })
        return false
      }
      return true
    },
    changeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    // 表单提交-非空检验
    dataFormSubmitHandle() {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          this.canUpdate = false
          return false
        }
        if (this.saved === true) {
          return false
        }
        // 如果经销商网点
        if (this.dataForm.orgType === '50' || this.dataForm.orgType === '60') {
          // 兼职一网点不空且职位空，视为兼职1没填好
          if (
             (this.dataForm.partTimeOutletOne !== null && this.dataForm.partTimeOutletOne !== '') &&
              (this.dataForm.partTimeJobcodeOne === null || this.dataForm.partTimeJobcodeOne === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '1' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.canUpdate = false
            return false
          }
          // 兼职二网点不空且职位空，视为兼职2没填好
          if (
            (this.dataForm.partTimeOutletTwo !== null && this.dataForm.partTimeOutletTwo !== '') &&
            (this.dataForm.partTimeJobcodeTwo === null || this.dataForm.partTimeJobcodeTwo === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '2' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.canUpdate = false
            return false
          }
          // 兼职三网点不空且职位空，视为兼职3没填好
          if (
            (this.dataForm.partTimeOutletThree !== null && this.dataForm.partTimeOutletThree !== '') &&
            (this.dataForm.partTimeJobcodeThree === null || this.dataForm.partTimeJobcodeThree === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '3' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.canUpdate = false
            return false
          }
          // 兼职四网点不空且职位空，视为兼职4没填好
          if (
            (this.dataForm.partTimeOutletFour !== null && this.dataForm.partTimeOutletFour !== '') &&
            (this.dataForm.partTimeJobcodeFour === null || this.dataForm.partTimeJobcodeFour === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '4' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.canUpdate = false
            return false
          }
          // 兼职五网点不空且职位空，视为兼职5没填好
          if (
            (this.dataForm.partTimeOutletFive !== null && this.dataForm.partTimeOutletFive !== '') &&
            (this.dataForm.partTimeJobcodeFive === null || this.dataForm.partTimeJobcodeFive === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '5' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.canUpdate = false
            return false
          }


          //判断最后一个有值的兼职之前是否有空兼职
          let partTimeOutlets = [this.dataForm.partTimeOutletOne,this.dataForm.partTimeOutletTwo,this.dataForm.partTimeOutletThree,this.dataForm.partTimeOutletFour,this.dataForm.partTimeOutletFive]
          let leftPartTimeOutletIdx = -1
          let rightPartTimeOutletIdx = -1
          let leftStop = false

          //查找从左最后有值和从右最后有值的位置
          partTimeOutlets.forEach((el,idx)=> el ? leftStop ? rightPartTimeOutletIdx = idx : leftPartTimeOutletIdx = rightPartTimeOutletIdx = idx : leftStop = true)

          //判断逻辑
          //1、从所有兼职中是否找到值(有兼职才进行后继判断)
          //2、首次有值与最后有值的位置相同时不进行提示（表示中间没有空的兼职）
          if(leftPartTimeOutletIdx!=-1&&leftPartTimeOutletIdx!=rightPartTimeOutletIdx){
             this.$alert(this.$t('user.parttimeNotNull', { 'handle': leftPartTimeOutletIdx+2 }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }
        }
        this.canUpdate = true
      })
    },
    getActivitiApplicantInfo() {
      this.$request.getAct(
        '/act/operate/historyApplicantByProcessId',
          {
            processId: this.$route.query.processId
          }
        ).then((res, total, code, data) => {
          this.actHistoryApplicantData = JSON.parse(JSON.stringify(res))
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.reg-img {
  position: absolute;
  height: 143px;
  width: 19%;
  text-align: left;
}
.reg-img img {
  max-height: 143px;
  max-width: 100%;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 23px 0;
}
.el-divider {
  background-color: #dcdfe6;
  position: relative;
}
.addbutton {
  background-color: white;
  border: none;
}
.addbutton:hover {
  cursor: pointer;
}
.delebutton:hover {
  cursor: not-allowed;
}
.custom{
    opacity: 1;
    -webkit-text-fill-color:#5c9df5;
}
.fl-input.is-disabled  .el-input__inner {
  color: blue !important;
  text-decoration:underline;
  cursor:pointer;
}
</style>
<style lang="scss">
.user-transfer-islimit-modal {
  border-radius: 4px !important;
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  .el-dialog__header{
    padding: 15px 15px 10px;
  }
  .el-dialog__body {
    padding: 0 !important;
    color: #606266;
    font-size: 14px;
    overflow: hidden;
  }
}
</style>
